import { render, staticRenderFns } from "./InstagramList.vue?vue&type=template&id=1dc57a0e&scoped=true&"
import script from "./InstagramList.vue?vue&type=script&lang=js&"
export * from "./InstagramList.vue?vue&type=script&lang=js&"
import style0 from "./InstagramList.vue?vue&type=style&index=0&id=1dc57a0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc57a0e",
  null
  
)

export default component.exports